import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useNavigate, useParams } from "react-router-dom"
import { ServiceDescriptor } from '../models/ServiceDescriptor';
import { useLevelMenu } from '../atoms/menu';
import { useActivityFilter } from '../atoms/filtri';
import { Fab, Paper, Popover, TableCell, TableContainer } from '@mui/material';
import { Suspense, useState } from 'react';
import TailSpinLoader from '../components/TailSpinLoader';
import CloseSectionIcon from '@mui/icons-material/KeyboardArrowUp'
import OpenSectionIcon from '@mui/icons-material/KeyboardArrowDown'
import TableView from '../framework/ui/view/table';
import { Star } from '../svgicons/Star';
import { StarFill } from '../svgicons/StarFill';
import { InfoCircle } from '../svgicons/InfoCircle';
import { Stickies } from '../svgicons/Stickies';
import { useStartApplication } from '../components/StartApplication';
import { useEditPreferito } from '../atoms/preferito';
import { useIsAdmin } from '../atoms';
import AddIcon from '@mui/icons-material/Add'
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { serviceAtom, serviceEditMode, serviceRequestNumberState } from '../atoms/serviceDescriptor';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import CloneIcon from '@mui/icons-material/ContentCopy';
import { useLogger } from '../framework/logger';
import api from '../services/api';
import { useConfirmDialog } from '../components/ConfirmDialog';
import _ from 'lodash';
import { usePreferitoForSdExists } from '../atoms/portale';
import { notPrefStarColor, prefStarColor } from '../Constants';
import BannerSelector from '../components/BannerSelector';
// import logConstants from '../utils/logConstants';

const filtroOk = (m: ServiceDescriptor, filtro?: string) => {
    if (!filtro) return true
    if (m.urlDescription.toLowerCase().indexOf(filtro.toLowerCase()) >= 0) return true
    if (m.note && m.note.toLowerCase().indexOf(filtro.toLowerCase()) >= 0) return true
}

const initialSectionOpen: Record<string, boolean> = { "Applicazioni": true, "Circolari": false, "Link Utili": false }
const initialSectionClosed: Record<string, boolean> = { "Applicazioni": false, "Circolari": false, "Link Utili": false }
const sdSezioni = ['Applicazioni', 'Circolari', 'Link Utili']

export const DoActivityAreaLevelPage = () => {
    const { area, level } = useParams()
    const levelMenu = useLevelMenu(area ?? '')
    const [sectionOpen, setSectionOpen] = useState(initialSectionOpen)
    // console.log(`%cDoActivityAreaLevelPage: levelMenu: ${levelMenu?.livello}, area: ${area}, level: ${level}`, logConstants.green10ptBold)
    const toggleOpen = (name: string, currentOpen: boolean) => {
        setSectionOpen({ ...initialSectionClosed, [name]: !currentOpen })
    }

    if (!level || !levelMenu) return <div></div>;

    return (
        <Suspense fallback={(<TailSpinLoader position='relative' height={32} width={32} left={32} top={32} justifyContent='flex-start' />)}>
            {levelMenu &&
                <>
                <Box sx={{ mx: 1, mt: 1 }}>
                    {sdSezioni.map((sez, idx) => <SdSectionView
                        key={idx}
                        name={sez}
                        items={levelMenu[sez]}
                        open={sectionOpen[sez]}
                        onToggleOpen={(currentOpen) => toggleOpen(sez, currentOpen)} />)
                    }
                </Box>
                </>
            }
        </Suspense>
    )
}

export const SdShow = ({ servDesc }: { servDesc: ServiceDescriptor }) => {
    return (
        <Box>
            {servDesc.urlDescription} - {servDesc.note}
        </Box>
    )
}

export type CodiciApplType = {
    open: boolean,
    appl?: ServiceDescriptor,
    uffi?: string,
    label?: string,
    invite?: string,
}

export const SdSectionView = ({ name, items, open, onToggleOpen }: { name: string, items: ServiceDescriptor[], open: boolean, onToggleOpen: (currentOpen: boolean) => void }) => {
    const preferitoExists = usePreferitoForSdExists()
    const [af,] = useActivityFilter()
    const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
    const [showInfo, setShowInfo] = useState<Record<number, boolean>>({})
    const startApplication = useStartApplication()
    const editPreferito = useEditPreferito()
    const isAdmin = useIsAdmin()
    const navigate = useNavigate()
    const serviceMode = useRecoilValue<string>(serviceEditMode)
    const { t } = useTranslation()
    const logger = useLogger({ key: 'service' });
    const setService = useSetRecoilState(serviceAtom)
    const { openConfirm, closeConfirm } = useConfirmDialog()
    const setServiceRequestNumberState = useSetRecoilState<number>(serviceRequestNumberState)

    const handleAddService = (ev: React.MouseEvent<HTMLButtonElement>) => {
        // console.log('Add service')
        ev.preventDefault()
        ev.stopPropagation()
        navigate('/service/0');
    }

    const handlePrefOnClick = (sd: ServiceDescriptor) => (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault()
        event.stopPropagation()
        // console.log(`Imposta preferito per ${sd.id} => ${sd.urlDescription}`)

        editPreferito(sd)
    }

    const handleOpen = (event: React.MouseEvent<HTMLDivElement>, id: number) => {
        event.preventDefault()
        event.stopPropagation()
        setShowInfo({ [id]: true });
        setAnchorEl(event.currentTarget);
    }

    const handleClose = (id: number) => {
        setAnchorEl(null);
        setShowInfo({ [id]: false });
    }

    const handleStartAppl = (sd: ServiceDescriptor) => (ev: React.MouseEvent<HTMLDivElement>) => {
        ev.stopPropagation()
        ev.preventDefault()
        // console.log(`DoActivityAreaLevelPage: Start Application: ${sd.id}`)
        startApplication(sd)
    }

    const handleDeleteService = (item: ServiceDescriptor) => (ev: React.MouseEvent<HTMLTableCellElement>) => {
        if (!isAdmin) {
            logger.warning(t('Non hai i diritti per eseguire l\'operazione'))
            return
        }
        openConfirm({
            title: t('Cancellazione Service descriptor'),
            prompt: t('Elimino il service?'),
            cancelText: t('Annulla'),
            confirmText: t('Cancella'),
            cancel: () => closeConfirm(),
            confirm: () => {
                api.deleteServiceDescriptor(item.id).then(() => setServiceRequestNumberState(r => r + 1))
                // console.log('Cancellazione Effettuata')
                closeConfirm()
            },
            onClose: () => closeConfirm(),
            children: (
                <>
                    <Typography component='div' sx={{ mb: 0.5, fontWeight: 'bold' }} variant='body1'>{item.urlDescription}</Typography>
                    <Typography component='div' sx={{ mb: 2 }} variant='body2'>{item.url}</Typography>
                </>
            )
        })
    }

    const handleEditService = (item: ServiceDescriptor) => (ev: React.MouseEvent<HTMLTableCellElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        console.log('item in Edit', item)
        // api.getNews(item.id).then(result => {
        //     if (result) {
        //         //console.log('result in Edit', result)
        //         setNews(result)
        //         navigate('ednews/' + item.id);
        //     }
        // })
        setService(item)
        navigate('/service/' + item.id);
    }
    const handleCloneService = (item: ServiceDescriptor) => (ev: React.MouseEvent<HTMLTableCellElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        console.log('item clonato ed in Edit', item)
        const newItem = _.cloneDeep(item)
        newItem.id = 0
        setService(newItem)
        navigate('/service/' + newItem.id);
    }

    // console.log('isAdmin', isAdmin)
    if (!items || items.length <= 0) return null
    return (
        <Box sx={{ position: 'relative' }}>
            <Paper sx={{ bgcolor: (theme) => theme.palette.primary.main /*grey[200]*/, px: 2, py: '2px', my: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }} onClick={() => onToggleOpen(open)}>
                <Box sx={{ cursor: 'pointer' }} color='#fff'>{open ? <CloseSectionIcon /> : <OpenSectionIcon />}</Box>
                <Typography color='#fff'>{name}</Typography>
                <Typography variant="body2" color='#fff'><small><em>({items.length})</em></small></Typography>
            </Paper>
            {open &&
                <TableContainer>
                    {isAdmin && serviceMode === 'edit' && <Fab size="small" color="primary" sx={{ position: 'absolute', top: -2, right: 8, zIndex: 3 }} onClick={handleAddService}><AddIcon /></Fab>}
                    <TableView
                        items={items.filter(m => (!af.authorizedOnly || (af.authorizedOnly && m.enabled)) && filtroOk(m, af.filter))}
                        itemKey={(item: ServiceDescriptor) => item.id}
                        thDefs={<>
                            <TableCell><Typography color='primary'>Applicazione</Typography></TableCell>
                            <TableCell><Typography color='primary'>Descrizione</Typography></TableCell>
                            <TableCell sx={{ cursor: 'pointer', maxWidth: '50px', textAlign: 'center' }}><Typography color='primary'>Preferito</Typography></TableCell>
                            <TableCell sx={{ cursor: 'pointer', maxWidth: '50px', textAlign: 'center' }}><Typography color='primary'>Info</Typography></TableCell>
                            {isAdmin && serviceMode === 'edit' &&
                                <TableCell sx={{ textAlign: 'center' }}>
                                    <Typography color='primary'>{t('Azioni')}</Typography>
                                </TableCell>
                            }
                        </>}
                        trDefs={(row: ServiceDescriptor) => (<>
                            <TableCell onClick={handleStartAppl(row)} sx={{ cursor: 'pointer', fontWeight: row.enabled ? 'bold' : 'normal', color: (theme) => theme.palette.secondary.dark }}>
                                {row.urlDescription}
                                {!row.guid && <span className="ms-2"><Stickies size={12} /></span>}
                            </TableCell>
                            <TableCell onClick={handleStartAppl(row)} sx={{ cursor: 'pointer' }}>{row.note}</TableCell>
                            <TableCell sx={{ cursor: 'pointer', maxWidth: '50px' }}>
                                <Box sx={{ textAlign: 'center' }}>
                                    {!row.enabled
                                        ? <Star size={20} />
                                        : <Box onClick={handlePrefOnClick(row)}>
                                            <StarFill size={20} color={preferitoExists(row.id) ? prefStarColor : notPrefStarColor} />
                                        </Box>
                                    }
                                </Box>
                            </TableCell>
                            <TableCell sx={{ maxWidth: '50px' }}>
                                <Box style={{ textAlign: 'center' }}>
                                    {(row.info)
                                        ? (
                                            <>
                                                <Box onClick={(e: React.MouseEvent<HTMLDivElement>) => handleOpen(e, row.id)}>
                                                    <InfoCircle size={20} />
                                                </Box>
                                                <Popover
                                                    id='popover-positioned-top'
                                                    open={showInfo[row.id] ?? false}
                                                    anchorEl={anchorEl}
                                                    onClose={() => handleClose(row.id)}
                                                    transitionDuration="auto"
                                                >
                                                    <Box sx={{ maxWidth: '400px', p: 1 }}>
                                                        <Typography sx={{ textAlign: 'center', my: 1, fontSize: '1.17rem', fontWeight: 800 }}>{row.urlDescription}</Typography>
                                                        <Box dangerouslySetInnerHTML={{ __html: row.info }}></Box>
                                                    </Box>
                                                </Popover>
                                            </>
                                        )
                                        : <Box>&nbsp;</Box>
                                    }
                                </Box>
                            </TableCell>
                            {isAdmin && serviceMode === 'edit' &&
                                <TableCell sx={{display: 'flex', justifyContent: 'center' }}>
                                    <Box sx={{display: 'flex', gap: 0.5, cursor: 'pointer', textAlign: 'center', height: '100%', pt: '6px', pb: 0}}>
                                        <Box onClick={handleDeleteService(row)} sx={{width: 20, height: 20}}> 
                                            <DeleteIcon fontSize='small' titleAccess={t('Elimina')} color='primary' />
                                        </Box>
                                        <Box onClick={handleEditService(row)} sx={{width: 20, height: 20}}> 
                                            <EditIcon fontSize='small' titleAccess={t('Modifica')} color='primary' />
                                        </Box>
                                        <Box onClick={handleCloneService(row)} sx={{width: 20, height: 20}}> 
                                            <CloneIcon fontSize='small' titleAccess={t('Clona')} color='primary' />
                                        </Box>
                                    </Box>
                                </TableCell>
                            }
                        </>)}
                    />
                </TableContainer>
            }
        </Box>
    )
}
